import { pagelink } from "@/config/site";
import { useTranslation } from "next-i18next";
import _ from "lodash";
import { FaAngleRight } from "react-icons/fa";

/**
 * This component compile and return a set of breadcrumb.
 * 
 * @param {BreadcrumbProps} props
 * @returns {JSX.Element}
 */
export function Breadcrumb({ currentPage = {}, previousPage = [] }) {
    const { t: lang } = useTranslation();

    const liStyle = {
        color: '#0b0b0b',
        fontWeight: 400,
        fontSize: 14,
        lineHeight: 1,
        textTransform: "capitalize"
    };

    const olStyle = {
        whiteSpace: 'nowrap',
        display: 'flex',
        flexWrap: 'nowrap',
        alignItems: 'center',
        width: '100%',
        overflow: 'scroll',
    };

    const aStyle = {
        fontSize: 14,
        lineHeight: 1
    };

    const pageLink = [
        {
            pageName: lang('Home'),
            pageLink: pagelink.home.homepage
        },
        ...previousPage,
        currentPage
    ].filter(value => Object.keys(value).length !== 0);

    return (
        <nav className="py-2">
            <ol itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumb py-1" style={ olStyle }>
                {
                    pageLink.map((page, index) => !_.isEmpty(page) &&
                        <li
                            key={ page.pageName }
                            className="breadcrumb-item px-0 d-flex align-items-center"
                            style={ liStyle }
                            itemScope
                            itemProp="itemListElement"
                            itemType="http://schema.org/ListItem"
                        >
                            <a itemType="http://schema.org/Thing" itemProp="item" title={ page.pageName } href={ page.pageLink } style={ aStyle }>
                                <span itemProp="name">{ page.pageName }</span>
                            </a>
                            { index + 1 !== pageLink.length && <FaAngleRight className="px-1" /> }
                            <meta itemProp="position" content={ index }></meta>
                        </li>
                    )
                }
            </ol>
        </nav>
    );
}